export const emailConstants = {
  emailjs: {
    serviceId: 'service_uhnkwea',
    templateId: 'template_2nrkw79',
    publicKey: 'Zipy6hh2McC7IpfVj'
  },
  defaultRecipient: 'info@defendokravmaga.it'
}
